import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import SingleService from './pages/SingleService';
import CaseStudies from './pages/CaseStudies';
import SingleCaseStudy from './pages/SingleCaseStudy';
import Portfolio from './pages/Portfolio';
import Blog from './pages/Blog';
import BlogContent2 from './components/sections/BlogContent2';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import Navbar from './components/layout/Navbar';
import Footer1 from './components/sections/Footer1';
import WhatsAppButton from './components/common/WhatsAppButton';

// Admin imports
import AdminLogin from './pages/admin/Login';
import AdminDashboard from './pages/admin/Dashboard';
import AdminBlogs from './pages/admin/Blogs';
import BlogEditor from './pages/admin/BlogEditor';
import PrivateRoute from './utils/PrivateRoute';
import { AuthProvider } from './context/AuthContext';
import AdminLayout from './components/admin/AdminLayout';
import BlogList from './pages/admin/BlogList';
import PortfolioList from './pages/admin/PortfolioList';
import PortfolioForm from './pages/admin/PortfolioForm';
import CategoryList from './pages/admin/CategoryList';
import Contacts from './pages/admin/Contacts';
import PrivacyPolicy from './pages/PrivacyPolicy';

function App() {
  console.log('App component rendering');

  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />

          {/* Protected Admin Routes */}
          <Route
            path="/admin"
            element={
              <PrivateRoute>
                <AdminLayout />
              </PrivateRoute>
            }
          >
            <Route path="dashboard" index element={<AdminDashboard />} />
            <Route path="blogs" element={<BlogList />} />
            <Route path="blogs/new" element={<BlogEditor />} />
            <Route path="blogs/:id/edit" element={<BlogEditor />} />
            <Route path="portfolio" element={<PortfolioList />} />
            <Route path="portfolio/new" element={<PortfolioForm />} />
            <Route path="portfolio/edit/:id" element={<PortfolioForm />} />
            <Route path="portfolio/categories" element={<CategoryList />} />
            <Route path="contacts" element={<Contacts />} />
          </Route>

          {/* Public Routes */}
          <Route
            path="/*"
            element={
              <div className="min-h-screen bg-black text-white">
                <Navbar />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/services/:serviceId" element={<SingleService />} />
                  <Route path="/case-studies" element={<CaseStudies />} />
                  <Route path="/case-studies/:caseId" element={<SingleCaseStudy />} />
                  <Route path="/portfolio" element={<Portfolio />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:slug" element={<BlogContent2 />} />
                  <Route path="/careers" element={<Careers />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                </Routes>
                <Footer1 />
                <WhatsAppButton />
              </div>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
